Namespace 'Monitoring.Reports.Publications.Content'

class Monitoring.Reports.Publications.Content.AnalyticsView extends Backbone.View

  className: 'content-section content-analytics'
  template: JST['backbone/templates/monitoring/reports/publications/content/analytics']
  twitterTemplates: JST['backbone/templates/monitoring/reports/publications/content/twitter_analytics']

  initialize: (@options = {}) ->

    # just set @options

  render_twitter: ->

  render: ->

    # content = @options.contents[0]
    # content_type = content.type
    # content_ids = _.map(@options.contents, (content) -> content.content_id)

    # params =
    #   date_since: @options.date_since
    #   date_until: @options.date_until
    #   content_ids: content_ids
    #   content_type: content_type

    # $.ajax
    #   type: 'post'
    #   url: '/monitoring/reports/publications/analytics'
    #   data: params
    #   success: @renderResults
    #   error: @fail

  fill_analytics: (metrics) -> 

    @$el.addClass('rendered')
    @$el.html(@template({ metrics: metrics }))
    @trigger('rendered')
  
  fill_twitter_analytics: (metrics) ->
    @$el.addClass('rendered')
    @$el.html(@twitterTemplates({ metrics: metrics }))
    @trigger('rendered')
  

  # renderResults: (data) =>

  #   @$el.html(@template({ metrics: data }))
  #   @trigger('rendered')

  fail: =>

    @trigger('fail')
